import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../../FJModal';
import FJTextToSpeechModal from '../view/FJTextToSpeechModal';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionTextToSpeechProject from '../../../../redux/action/FJActionTextToSpeechProject';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import FJUtil from '../../../../util/FJUtil.js';

const FJTextToSpeechModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const ttvProjectInfo = useSelector(state => state.textToSpeech.ttvProjectInfo);
    const isShowTTVProjectModal = useSelector(state => state.textToSpeech.isShowTTVProjectModal);

    const onClose = useCallback(() => {
        FJAudioPlayManager.pauseAll();
        dispatch(FJActionTextToSpeechProject.closeTTVProjectModalAction());
    }, [dispatch]);

    const _onDownload = urls => {
        FJUtil.eaLog('speech_download_click', { position: 'history' });
        dispatch(FJActionTextToSpeech.multiDownloadAction(urls));
    };

    const _onEdit = () => {
        FJUtil.eaLog('history_edit_click');
        FJAudioPlayManager.pauseAll();
        dispatch(FJActionTextToSpeechProject.onEditAction(ttvProjectInfo.pid, { list: ttvProjectInfo.list }));
    };

    const _onUseToFlexClip = () => {
        FJUtil.eaLog('ai tool multiple media to editor', {
            tool: 'text_to_speech',
            number: ttvProjectInfo.list.length,
        });
        FJUtil.eaLog('use_in_flexclip_click', { position: 'history' });
        dispatch(FJActionTextToSpeechProject.onUseToFlexClipAction(ttvProjectInfo.list));
    };

    if (!isShowTTVProjectModal) {
        return;
    }

    return (
        <FJModal visible={isShowTTVProjectModal}>
            <FJTextToSpeechModal
                onClose={onClose}
                info={ttvProjectInfo}
                onDownload={_onDownload}
                onEdit={_onEdit}
                onUseToFlexClip={_onUseToFlexClip}
            />
        </FJModal>
    );
};
export default FJTextToSpeechModalContainer;
